"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var URI = /** @class */ (function () {
    function URI(_a) {
        var scheme = _a.scheme, host = _a.host, port = _a.port, path = _a.path, query = _a.query;
        this.scheme = scheme || constants_1.SCHEME_HTTP;
        this.host = host;
        this.port = port || (scheme === constants_1.SCHEME_HTTPS ? constants_1.DEFAULT_HTTPS_PORT : constants_1.DEFAULT_HTTP_PORT);
        this.path = path;
        this.query = query || '';
    }
    URI.prototype.toString = function () {
        return URI.stringifyURI(this);
    };
    URI.stringifyURI = function (uri) {
        var portFragment = URI.isPortStandard(uri.scheme, uri.port) ? '' : ':' + String(uri.port);
        var hostFragment = uri.host + portFragment;
        var schemeFragment = uri.scheme + "://";
        var pathFragment = uri.path === '' ? '/' : uri.path;
        var searchFragment = !uri.query ? '' : '?' + uri.query;
        return schemeFragment + hostFragment + pathFragment + searchFragment;
    };
    URI.isPortStandard = function (scheme, port) {
        return ((scheme === constants_1.SCHEME_HTTPS && port === constants_1.DEFAULT_HTTPS_PORT) || (scheme === constants_1.SCHEME_HTTP && port === constants_1.DEFAULT_HTTP_PORT));
    };
    return URI;
}());
exports.URI = URI;
//# sourceMappingURL=uri.js.map